import { ClockWorkModule } from "@/store/modules/clockWork.module";
import { Machine } from "xstate";
const clockWorkPieChartMachine = Machine({
    id: "clockWorkPieChart",
    context: {},
    initial: "idle",
    states: {
        idle: {
            on: {
                GETTING_PROJECTS: "gettingProjectDetails",
            },
        },
        gettingProjectDetails: {
            invoke: {
                id: "gettingProjectDetails",
                src: (ctx, event) => {
                    return ClockWorkModule.GetClockWorkProjectSummaries(event.operationDate);
                },
                onDone: { target: "loadedProjectDetails" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedProjectDetails: {
            on: {
                GETTING_PROJECTS: "gettingProjectDetails",
                CLOSE_MODAL: "idle",
            },
        },
        serviceUnavailable: {},
    },
}, {
    guards: {},
    actions: {},
});
export default clockWorkPieChartMachine;
